export interface Newsletter {
  id: number;
  subscriptionId: number;
  automaticSubscriptionId: number;
  emarsysId: number;
  mode: ModeEnum;
  name: string;
  label: string;
  title: string;
  subtitle: string;
  description: string;
  visibleFor: VisibilityEnum;
  visible: boolean;
  preview: string;
  landingPage: string;
  buttonClass: ButtonClassEnum;
  buttonText: ButtonTextEnum;
  buttonChecked: boolean;
  apiError: boolean;
  isNewSubscriberSubmit: boolean;
}

export enum ModeEnum {
  Email = 'email',
  Uid = 'uid',
}

export enum VisibilityEnum {
  All = 'all',
  LoggedIn = 'logged-in',
  Plus = 'plus',
  Club = 'club'
} 

export enum ButtonTextEnum {
  Subscribed = 'Newsletter aktiviert',
  Unsubscribed = 'Jetzt aktivieren',
  BlockedByPlus = 'Aktivierung nur mit Abo möglich',
}

export enum ButtonClassEnum {
  Subscribe = 'subscribe',
  Unsubscribe = 'unsubscribe',
  BlockedByPlus = 'blocked',
}
